import { useState } from "react";
import { Card, CardContent, CardMedia, Button, Avatar } from "@mui/material";
import { courses } from "../Data/courses";

const CARD_WIDTH = 300;
const CARD_HEIGHT = 460;

const CoursesCarousel = () => {
  const [index, setIndex] = useState(0);
  const VISIBLE_CARDS = 3;
  const maxIndex = Math.max(courses.length - VISIBLE_CARDS, 0);

  const next = () => setIndex(i => (i >= maxIndex ? 0 : i + 1));
  const prev = () => setIndex(i => (i === 0 ? maxIndex : i - 1));

  return (
    <section className="w-full bg-gray-50 py-16">
      <h2 className="text-3xl font-semibold text-center mb-10">Our Courses</h2>

      <div className="relative max-w-[1200px] mx-auto">
        <div className="overflow-hidden">
          <div
            className="flex transition-transform duration-500"
            style={{ transform: `translateX(-${index * (CARD_WIDTH + 16)}px)` }}
          >
            {courses.map((course, i) => (
              <div key={i} className="flex-shrink-0 w-[300px] mx-2">
                <Card
                  className="rounded-2xl shadow-lg flex flex-col"
                  style={{ width: CARD_WIDTH}}
                >
                  {/* IMAGE + BUTTON */}
                  <div className="relative w-full h-40 overflow-hidden">
                    <CardMedia
                      component="img"
                      image={course.image}
                      alt={course.title}
                      style={{ width: "100%",  objectFit: "cover" }}
                    />
                    <Button
                      variant="contained"
                      sx={{
                        position: "absolute",
                        bottom: 12,
                        left: "50%",
                        transform: "translateX(-50%)",
                        px: 3,
                        py: 0.8,
                        fontSize: "0.8rem",
                        borderRadius: "20px",
                        backgroundColor: "#15803d",
                        textTransform: "none",
                        fontWeight: 600,
                        "&:hover": { backgroundColor: "#166534" },
                      }}
                    >
                      Study Now
                    </Button>
                  </div>

                  {/* CONTENT */}
                  <CardContent className="flex flex-col justify-between flex-1 ">
                    <div>
                      <h3 className="font-semibold mb-2 line-clamp-2">{course.title}</h3>

                      {/* Stats */}
                      <div className="flex justify-between text-center mb-4 text-sm">
                        <div>
                          <p className="font-semibold text-green-700">{course.lessons}</p>
                          <p className="text-gray-500">lessons</p>
                        </div>
                        <div>
                          <p className="font-semibold text-green-700">{course.weeks}</p>
                          <p className="text-gray-500">weeks</p>
                        </div>
                        <div>
                          <p className="font-semibold text-green-700">{course.enrolled}</p>
                          <p className="text-gray-500">enroll</p>
                        </div>
                      </div>
                    </div>

                    {/* Footer */}
                    <div className="flex items-center justify-between bg-gray-100 rounded-xl p-3 gap-2">
                      <div className="flex items-center gap-2 min-w-0">
                        <Avatar src={course.instructorImg} sx={{ width: 34, height: 34 }} />
                        <div className="min-w-0">
                          <p className="truncate text-sm font-medium">{course.instructor}</p>
                          <p className="text-xs text-gray-500">Arabic Teacher</p>
                        </div>
                      </div>
                      <div className="bg-yellow-400 text-black text-xs font-semibold px-3 py-1.5 rounded-lg">
                        ${course.price}
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>
            ))}
          </div>
        </div>

        {/* Left Arrow */}
        <button
          onClick={prev}
          className="absolute left-0 top-1/2 -translate-y-1/2 bg-white shadow-lg rounded-full w-12 h-12 flex items-center justify-center hover:bg-blue-100 transition"
        >
          ←
        </button>

        {/* Right Arrow */}
        <button
          onClick={next}
          className="absolute right-0 top-1/2 -translate-y-1/2 bg-white shadow-lg rounded-full w-12 h-12 flex items-center justify-center hover:bg-blue-100 transition"
        >
          →
        </button>
      </div>
    </section>
  );
};

export default CoursesCarousel;
